/**************************************************************************************************/
/*   File: /src/app/shared/models/dossier.summary.ts                                              */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Mar 29 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { DocumentStatusEnum } from '../enums/document.status.enum';
import { ReportStatusEnum } from '../enums/report.status.enum';
import { Description } from './description';
import { DossierStatus } from './dossier.status';
import { ExternalUser } from './external.user';
import { ReportStatus } from './report.status';
import { DocumentStatus } from './document.status';
import { SpatialDataTypeEnum } from '../enums';

/**
 * Dossier
 */
export class DossierSummary {
    /**
     * The creation date
     */
    creationDate: Date;
    /**
     * The id
     */
    id: number;
    /**
     * The other report status;
     */    
    otherReportStatus: ReportStatus;
    /**
     * The other status
     */
    otherStatus: DocumentStatus;
    /**
     * The owner
     */
    owner: ExternalUser;
    /**
     * The plan type
     */
    plan: Description;
    /**
     * The is regulations dossier
     */
    regulationsDossier: boolean;
    /**
     * The regulations report status
     */
    regulationsReportStatus: ReportStatus;
    /**
     * The regulations status
     */
    regulationsStatus: DocumentStatus;
    /**
     * The spatial dossier
     */
    spatialDossier: boolean;
    /**
     * The spatial report status
     */
    spatialReportStatus: ReportStatus;
    /**
     * The spatial status
     */
    spatialStatus: DocumentStatus;
    /**
     * The status
     */
    status: DossierStatus;
    /**
     * The territorial areas
     */
    territorialAreas: Description[];
    /**
     * The default spatial data type
     */
    defaultSpatialDataType: SpatialDataTypeEnum;
    /**
     * The delivery date
     */
    deliveryDate?: Date;
}